import axios from 'axios';
import { func } from '.';
import OneSignal from 'onesignal-cordova-plugin';

export const signout = (_update?: any) => {
	func.isMobile && OneSignal.logout();
	if (_update) {
		_update.auth('user', {});
		_update.auth('token', '');
	}
	func.delStorage('user');
	func.delStorage('token');
	func.init();
	window.location.replace('/login');
	window.location.reload();
};

export const apnData = (obj: any) => {
	const body = new FormData();
	for (let p in obj) {
		if (Array.isArray(obj[p])) {
			for (let i = 0; i < obj[p].length; i++) {
				body.append(`${p}[${i}]`, obj[p][i]);
			}
		} else {
			body.append(p, obj[p]);
		}
	}
	return body;
};

export const apiHeaders = (type: string = ''): any => {
	func.init();
	const token = func.getStorage('token') || '';
	const deviceId =
		func.getStorage('deviceId') || func.randomCode(32, ['a', 'n']);
	func.setStorage('deviceId', deviceId);
	if (type === 'file') {
		return {
			'Accept': 'application/json',
			'x-device-id': `${deviceId}`,
			'x-app-version': func.app.version,
			'x-access-token': `${token}`,
		};
	} else {
		return {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'x-device-id': `${deviceId}`,
			'x-app-version': func.app.version,
			'x-access-token': `${token}`,
		};
	}
};

export const checkFullURL = (action: string) => {
	if (action.indexOf('http://') > -1 || action.indexOf('https://') > -1) {
		return action;
	}
	return func.config.apiURL + action;
};

export const get = async (action: string, data = {}) => {
	const headers = apiHeaders();
	const url = checkFullURL(action);
	return axios({
		method: 'GET',
		url,
		headers,
		params: data,
	})
		.then((response) => {
			return respunse(response.data, response.status);
		})
		.catch((e) => {
			const response = e.response;
			return respunse(response?.data, response?.status);
		});
};

export const post = async (action: string, data = {}) => {
	const url = checkFullURL(action);
	const headers = apiHeaders();
	return axios({
		method: 'POST',
		url,
		headers,
		data,
	})
		.then((response) => {
			return respunse(response.data, response.status);
		})
		.catch((e) => {
			const response = e.response;
			return respunse(response?.data, response?.status);
		});
};

export const put = async (action: string, data = {}) => {
	const url = checkFullURL(action);
	const headers = apiHeaders();
	return axios({
		method: 'PUT',
		url,
		headers,
		data,
	})
		.then((response) => {
			return respunse(response.data, response.status);
		})
		.catch((e) => {
			const response = e.response;
			return respunse(response?.data, response?.status);
		});
};

export const delte = async (action: string, data = {}) => {
	const url = checkFullURL(action);
	const headers = apiHeaders();
	try {
		const response = await fetch(url, {
			method: 'DELETE',
			headers,
			body: JSON.stringify(data),
		});
		return respunse(await response.json(), response.status);
	} catch (error) {
		return { status: 505, result: 'Network request failed', error };
	}
};

export const postFile = async (action: string, data = {}) => {
	const url = checkFullURL(action);
	const headers = apiHeaders('file');
	try {
		const response = await fetch(url, {
			method: 'POST',
			headers,
			body: apnData(data),
		});
		return respunse(await response.json(), response.status);
	} catch (error) {
		return { status: 505, result: 'Network request failed', error: error };
	}
};

const respunse = (res: any, status: number) => {
	if ([401].includes(status) && func.getStorageJson('user').id) {
		signout();
		return { ...res, status };
	} else if (status === 412) {
		res = typeof res !== 'object' ? {} : res;
		res['message'] = res?.data ? res?.data.join(' | ') : res?.message;
	}
	return { ...res, status, message: res?.message || 'Something went wrong' };
};
